'use client'
import React from 'react'
import styles from './styles.module.scss'

interface TrashCloseIconProps {
  onClickHandler?: () => void
  isMobileSearch?: boolean
}

const TrashCloseIcon: React.FC<TrashCloseIconProps> = ({
  onClickHandler,
  isMobileSearch,
}) => (
  <button
    className={`${isMobileSearch ? styles.mobileSearchButton : styles.button}`}
    onClick={onClickHandler}
  >
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.33333 4.16699H5.83333V3.33366C5.83333 2.89163 6.00893 2.46771 6.32149 2.15515C6.63405 1.84259 7.05797 1.66699 7.5 1.66699H12.5C12.942 1.66699 13.3659 1.84259 13.6785 2.15515C13.9911 2.46771 14.1667 2.89163 14.1667 3.33366V4.16699H16.6667C16.8877 4.16699 17.0996 4.25479 17.2559 4.41107C17.4122 4.56735 17.5 4.77931 17.5 5.00033C17.5 5.22134 17.4122 5.4333 17.2559 5.58958C17.0996 5.74586 16.8877 5.83366 16.6667 5.83366H15.8333V16.667C15.8333 17.109 15.6577 17.5329 15.3452 17.8455C15.0326 18.1581 14.6087 18.3337 14.1667 18.3337H5.83333C5.39131 18.3337 4.96738 18.1581 4.65482 17.8455C4.34226 17.5329 4.16667 17.109 4.16667 16.667V5.83366H3.33333C3.11232 5.83366 2.90036 5.74586 2.74408 5.58958C2.5878 5.4333 2.5 5.22134 2.5 5.00033C2.5 4.77931 2.5878 4.56735 2.74408 4.41107C2.90036 4.25479 3.11232 4.16699 3.33333 4.16699ZM5.83333 5.83366V16.667H14.1667V5.83366H5.83333ZM7.5 4.16699H12.5V3.33366H7.5V4.16699ZM7.5 7.50033H9.16667V15.0003H7.5V7.50033ZM10.8333 7.50033H12.5V15.0003H10.8333V7.50033Z"
        fill="#ACAEC9"
      />
    </svg>
  </button>
)

export default React.memo(TrashCloseIcon)
